import React from 'react';
import { ShieldAlert } from 'lucide-react';

export default function ElevePermisBlancPage() {
  return (
    <div className="max-w-3xl" data-testid="eleve-permis-blanc-page">
      <div className="text-[10.5px] font-black uppercase tracking-[0.22em] text-rose-500 mb-2">Suspension · Retrait</div>
      <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
        Permis blanc
      </h1>
      <p className="text-sm text-white/60 mt-2 mb-6">Guide et procédure en cas de suspension ou retrait de permis. Bientôt disponible.</p>
      <div className="rounded-2xl border border-dashed border-white/15 bg-white/[0.02] p-8 text-center">
        <ShieldAlert className="w-8 h-8 text-white/30 mx-auto mb-2" />
        <div className="text-white/60 text-sm">Section en cours de rédaction.</div>
      </div>
    </div>
  );
}
